const prefix = 'fac';
const iconName = 'merge-fallback';
const width = 515;
const height = 515;
const ligatures = [];
const unicode = null;
const svgPathData = 'M0 68C0 30.4446 30.4446 0 68 0H287C324.555 0 355 30.4446 355 68V287C355 324.555 324.555 355 287 355H68C30.4446 355 0 324.555 0 287V68Z M224 447C224 449.209 225.791 451 228 451H249V515H228C190.738 515 160.476 485.029 160.006 447.879L160 447V426H224V447ZM377 515H297V451H377V515ZM515 447L514.994 447.879C514.527 484.737 484.737 514.527 447.879 514.994L447 515H425V451H447C449.209 451 451 449.209 451 447V426H515V447ZM224 378H160V298H224V378ZM515 378H451V298H515V378ZM249 224H228C225.791 224 224 225.791 224 228V250H160V228C160 190.445 190.445 160 228 160H249V224ZM447.879 160.006C485.029 160.476 515 190.738 515 228V250H451V228C451 225.791 449.209 224 447 224H425V160H447L447.879 160.006ZM377 224H297V160H377V224Z';

export const definition = {
    prefix,
    iconName,
    icon: [
        width,
        height,
        ligatures,
        unicode,
        svgPathData,
    ],
};

export { definition as faMergeFallback };
